import angular from 'angular';

import FilePreviewComponent from './components/file-preview/file-preview-component';
import FilePreviewImageComponent from './components/file-preview-image/file-preview-image-component';
import FilePreviewPdfComponent from './components/file-preview-pdf/file-preview-pdf-component';

export default angular
  .module('file-preview', [])
  .component('filePreview', new FilePreviewComponent())
  .component('filePreviewImage', new FilePreviewImageComponent())
  .component('filePreviewPdf', new FilePreviewPdfComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/file-preview/file-preview-module.js